export function isOneOf<const TMember extends string>(
  allowed: readonly TMember[],
  value: unknown,
): value is TMember {
  return (
    typeof value === "string" &&
    allowed.some((candidate) => candidate === value)
  );
}

export function narrowToOneOf<const TMember extends string>(
  allowed: readonly TMember[],
  value: unknown,
): TMember | null {
  return isOneOf(allowed, value) ? value : null;
}

export function typedKeys<TObject extends object>(
  record: TObject,
): Array<Extract<keyof TObject, string>> {
  return Object.keys(record).filter(
    (key): key is Extract<keyof TObject, string> => key in record,
  );
}

export function typedEntries<TObject extends object>(
  record: TObject,
): Array<[Extract<keyof TObject, string>, TObject[Extract<keyof TObject, string>]]> {
  return typedKeys(record).map((key) => [key, record[key]]);
}
